export default "__VITE_ASSET__32b19c91__"